module.exports = __webpack_public_path__ + "static/media/BREAK_START.40509520.png";